






























































































































































































































































































































































































































































































/* Many methods & props originally templated from CreateEditCast & other components */
import Vue from 'vue'
import env from '../../env'
import { Table, TableColumn, Select, Option, Popover, DatePicker, Button } from 'element-ui'
import './EventWizard.scss'
import { CallTriage, EventWizardStep, InvitedCaster, SupportLevel } from '@/types/casts'
import { Feature } from '@/featureFlags/featureFlags'
import StreamOutputs from '@/components/StreamOutputs'
import CastInputSelector from '@/components/CastInputSelector'
// import AddCasterToCast from '@/components/AddCasterToCast'
// import ManageCasters from './ManageCasters'
// import ManageCastFolders from '@/components/ManageCastFolders'
// import ManageWidgets from '@/components/ManageWidgets'
import { between, minLength, required } from 'vuelidate/lib/validators'
import helpers from '../../helpers'
import moment from 'moment'
import { cloneDeep, sortBy, orderBy, pickBy } from 'lodash'
import { KeyDict, SelectOption } from '@/types'
import { Cast, CustomRtmpDestination, DEFAULT_SUPPORT_LEVEL, MIXER_DEFAULT_GOP } from '@/types/casts'
import { Release, WATERMARK_DEFAULT } from '@/store/types'
import { CastPropertyType, TranscodingRegion } from '@/types/admin'
import WRTCLoadbalancer from '@/classes/WRTCLoadbalancer'
import { WowzaStat } from '@/types/wowza'
import SubscribeWowzaStats from '@/mixins/SubscribeWowzaStats'
import SubscribeRelease from '@/mixins/SubscribeRelease'
import { CastProperty } from '@/types/admin'
import { Stream, StreamType } from '@/types/streams'
import { DropdownOption } from '@/types/dropdownOption'
import { CastTemplate } from '@/types/casttemplates'
import { UserProfile } from '@/types/users'
import { Region } from '@/types/ops'

const LARGE_MACHINE_TYPE = 'c5_18xlarge'
const NORMAL_MACHINE_TYPE = 'm5_12xlarge'

interface InvitedCasterRow {
  id: string
  name: string
}

const validDateRange = () => function (value: Date) {
  // @ts-ignore
  const startDate = moment(this.event.start_date, moment.ISO_8601)
  const endDate = moment(value, moment.ISO_8601)
  const validFormat = startDate.isValid() && endDate.isValid()
  if (!validFormat) return false

  let status = false
  // @ts-ignore
  if (this.isEditMode || !this.isCopyMode) {
    status = startDate.isBefore(endDate) && endDate.isAfter(moment())
  }
  return status
}

const allowedDateRange = () => function (value: Date) {
  // @ts-ignore
  return moment(value) <= moment(this.event.start_date).add(4, 'hours').add(1, 'minute') //Max 4 hr duration
  // I added the additional minute to the check to make sure there are no rounding errors in checking as we
  // automaticcaly create a 4hour cast
  // NOTE: If we add non-self-serve support to this component, we need to add separate validaiton for regular 24 hr max
}

/* Currently only being used for Self-Serve event creation */
export default Vue.extend({
  name: 'EventWizard',
  mixins: [SubscribeWowzaStats, SubscribeRelease],
  data: () => ({
    hasValidInputs: true,
    submitStatus: '',
    selectedTemplate: 'default',
    selectedCaster: null as string|null,
    // activeSection: 0, //Only used with Steps navigation
    hadOriginalOutputs: false,
    originalGop: MIXER_DEFAULT_GOP,
    originalEvent: {} as Cast | undefined,
    event: {
      name: '',
      input_streams: {},
      event_id: '',
      asset_groups: {},
      start_date: new Date(),
      end_date: moment().add(4, 'hours').toDate(),
      preview_scenes: {},
      deleted: false,
      record_isos: false,
      team_id: '',
      region: 'us-east',
      quality: '0720p006000',
      framerate: '30Hz',
      srt: false,
      supportLevel: DEFAULT_SUPPORT_LEVEL,
      pendingPlatinumRequest: false,
      platinumApproved: false,
      largemachine: false,
      create_event: true,
      invited_casters: {} as KeyDict<InvitedCaster>,
      online_sessions: {},
      custom_rtmp_destinations: {} as KeyDict<CustomRtmpDestination>,
      talk_back: {},
      widgets: {},
      template: '',
      watermark: WATERMARK_DEFAULT,
      gop_size: MIXER_DEFAULT_GOP,
      teamGroups: [] as string[]
    } as Cast, //Do we want to update this interface name to Event too?
  }),
  computed: {
    isSelfServe (): boolean {
      return this.$hasFeature(Feature.SELF_SERVE)
    },
    isCopyMode (): boolean {
      return !!this.event.copying
    },
    isEditMode (): boolean {
      return !!this.eventId
    },
    isActiveEvent (): boolean {
      // TODO: We might want to rename helper to 'event'
      return helpers.isActiveCast(this.event)
    },
    isSubmitting (): boolean {
      return this.submitStatus === 'submitting'
    },
    eventId (): string {
      return this.$route.params.id ?? ''
    },
    pageTitle (): string {
      return (this.isEditMode ? 'Edit' : this.isCopyMode ? 'Copy' : 'Create New') + ' Event'
    },
    submitBtnText (): string {
      return (this.isEditMode ? 'Update' : this.isCopyMode ? 'Copy' : 'Create') + ' Event'
    },
    steps (): EventWizardStep[] {
      if (this.isSelfServe) return [EventWizardStep.EVENT, EventWizardStep.INPUTS, EventWizardStep.OUTPUTS, EventWizardStep.CASTERS]
      return Object.values(EventWizardStep)
    },
    hasStarted (): boolean {
      return !!(this.isEditMode && this.originalEvent?.hasOwnProperty('name') && this.originalEvent?.start_date.seconds * 1000 < Date.now())
    },
    eventProperties (): KeyDict<CastProperty> {
      //Do we want to update this interface and state prop name to event too?
      return this.$store.direct.state.team.castProperties
    },
    activeTeam (): string {
      return this.$store.direct.state.team.activeTeam
    },
    transcodingregions (): KeyDict<TranscodingRegion> {
      return this.$store.direct.state.admin.transcodingregions
    },
    wowzastats (): KeyDict<WowzaStat> {
      return this.$store.direct.state.opsmonitor.wowzastats
    },
    release (): Release|null {
      return this.$store.direct.state.admin.release
    },
    teamVersion (): string {
      return this.$store.direct.state.team.team.version
    },
    ngcvpVersion (): string | null {
      if (this.release === null) return null
      const version = this.release.versions[this.teamVersion]
      return version?.ngcvp_version ?? null
    },
    kenv (): string {
      return env.environment
    },
    shouldShowGopWarning (): boolean {
      if (this.originalGop !== this.event.gop_size && this.hadOriginalOutputs) return true
      return false
    },
    streams (): KeyDict<Stream> {
      return this.$store.direct.state.team.streams
    },
    regions (): DropdownOption[] {
      const r: KeyDict<string> = {}
      Object.keys(this.castProperties).forEach(castPropertyId => {
        const castProperty = this.castProperties[castPropertyId]
        if (castProperty.type === CastPropertyType.Region) {
          r[castProperty.name] = castPropertyId
        }
      })
      const sortedNames = Object.keys(r).sort()
      const regionlist: DropdownOption[] = []
      sortedNames.forEach((name: string) => {
        regionlist.push({ name: name, key: r[name] } as DropdownOption)
      })
      return regionlist
    },
    qualities (): DropdownOption[] {
      return this.$store.direct.getters.team.allowedStreamQualityDropdownOptions
    },
    framerates (): DropdownOption[] {
      return this.$store.direct.getters.team.allowedStreamFramerateDropdownOptions
    },
    castProperties (): KeyDict<CastProperty> {
      return this.$store.direct.state.team.castProperties
    },
    heavyDutyAllowed (): boolean {
      return this.$hasFeature(Feature.HEAVY_DUTY_AVAILABLE)
    },
    templates (): CastTemplate[] {
      return this.$store.direct.state.castTemplates.templates
    },
    formattedTemplates (): SelectOption[] {
      let templates: SelectOption[] = []
      if(!!this.templates){
        templates = this.templates.map(template => {
          return { key: template.id, label: template.name }
        })
      }
      templates = sortBy(templates, [o => o.label.toLowerCase()])
      templates.unshift({ key: 'default', label: 'None' })
      return templates
    },
    loadedTemplate (): CastTemplate | null {
      return this.templates.find(template => template.id === this.selectedTemplate) ?? null
    },
    selectedResolution (): string {
      if (!this.event.quality) return ''
      return +this.event.quality.split('p')[0] + ''
    },
    currentTeam (): UserProfile[] {
      return this.$store.direct.state.team.currentTeam
    },
    teamStreams (): object {
      return this.$store.direct.state.team.streams
    },
    filteredTeamStreamInputs (): Stream[] {
      /* TODO: This is the same as listStreams() in CastInputSelector component.
        Set it up so that this pre-filtered collection can be sent as a prop,
        to avoid needlessly repeating the same calcuation.
      */
      const team = this.$store.direct.state.team.team
      let inputs: Stream[] = []
      Object.keys(this.teamStreams).forEach(streamid => {
        const stream = this.streams[streamid]
        if (!stream.deleted && stream.type === StreamType.Broadcast && stream.hasOwnProperty('name') && !stream.srcurl.startsWith('rtsp://')) {
          if (stream.auth_info !== undefined) {
            const streams_auth = team?.streams_auth?.[stream.auth_info.type]
            if (streams_auth === undefined || streams_auth.error || streams_auth.pending || !stream.auth_info.ingest_url || stream.auth_info.error) {
              return
            }
          }
          inputs.push(stream)
        }
      })
      inputs = sortBy(inputs, [o => o.name?.toLowerCase() ?? ''])
      return inputs
    },
    casters (): KeyDict<InvitedCaster> {
      const casters = this.event.invited_casters
      return pickBy(casters, (caster) => caster.triage !== CallTriage.Rejected && !caster.deleted)
    },
    allowedProfiles (): UserProfile[] {
      return orderBy(this.currentTeam.filter((profile) => {
        if (profile.anonymous) return false
        if (this.casters === undefined) return false
        if (profile.id === undefined) return false
        if (this.casters[profile.id] !== undefined) return false
        return true
      }), ['first_name'], ['asc'])
    },
    hasEmptySlots (): boolean {
      return this.$store.direct.getters.events.hasEmptySlots
    },
    canAddCasters (): boolean {
      if (this.selectedCaster === null) return false
      if (!this.hasEmptySlots) return false
      return true
    },
    invitedCastersRows (): InvitedCasterRow[] {
      const invitedIds = Object.keys(this.casters)
      return this.currentTeam
        .filter((profile) => invitedIds.includes(profile.id))
        .map((profile) => {
          const invitedCasterRow: InvitedCasterRow = {
            id: profile.id,
            name: `${ profile.first_name } ${ profile.last_name }`
          }
          if (profile.display_name) {
            invitedCasterRow.name += ` (${ profile.display_name })`
          }
          return invitedCasterRow
        })
    }
  },
  created (): void {
    this.init()
  },
  methods: {
    init (): void {
      this.updateOriginalGopInfo()
      if (this.isSelfServe) {
        this.event.supportLevel = SupportLevel.Lite
      }
    },
    /* Only used with Steps navigation
    goToStep (stepIndex): void {
      this.activeSection = stepIndex
    }, */
    showStep (stepName: EventWizardStep): boolean {
      // const currentStep: EventWizardStep = this.steps[this.activeSection]
      // return currentStep === stepName
      return this.steps.includes(stepName)
    },
    setValidNumberOfInputs (value: boolean): void {
      this.hasValidInputs = value
    },
    async saveEvent (): Promise<void> {
      this.$v.$touch()
      let outputValid = true
      Object.values(this.event.custom_rtmp_destinations || {}).forEach(output => {
        outputValid = outputValid && output.valid
      })
      // set/reset error status
      if (!this.hasValidInputs) {
        this.submitStatus = 'ERROR'
        // if (!this.isCopyMode) {
        //   this.activeSection = 1
        // }
      } else if (this.$v.$invalid || !outputValid || !this.validOutputs()) {
        this.submitStatus = 'ERROR'
        // this.activeSection = 0
      } else if (this.submitStatus === 'ERROR') {
        this.submitStatus = ''
      }

      // submit unless error or already submitting
      if (this.submitStatus === '') {
        this.submitStatus = 'submitting'

        if (this.isEditMode) this.updateEvent()
        else {
          //Prep new event data for saving
          if (this.event.region !== null) {
            const eventProps = Object.assign({}, this.eventProperties[this.event.region!], { name: this.event.name })
            delete eventProps.id

            const region = eventProps.transcodingregion ? this.transcodingregions[eventProps.transcodingregion] : undefined
            if (region !== undefined) {
              const balancer = new WRTCLoadbalancer()
              const wrtcserver = balancer.getServerUrlToStreamTo(region, this.wowzastats)
              if (wrtcserver !== undefined) eventProps.wrtcserver = wrtcserver
            }
            this.event = {
              ...this.event,
              ...eventProps,
            }
          }
          this.updatePresets()

          if (this.isSelfServe && !this.isEditMode && !this.isCopyMode) {
            //Assign all asset groups to new self-serve events
            const groupNames: string[] = await this.$store.direct.dispatch.events.getAllTeamAssetGroupIds(this.activeTeam) ?? []
            this.event.asset_groups = Object.fromEntries(groupNames.map(name => [name, true])) //Generate obj for db
          }

          if (this.isCopyMode) this.createEventCopy()
          else this.createEvent()
        }
      }
    },
    updatePresets (): void {
      if (this.event === undefined) return
      this.event.presets = []
      if (this.event.quality !== null) {
        const properties = this.eventProperties[this.event.quality]
        if (properties !== undefined) this.appendPresets(properties.presets)
      }
      if (this.event.framerate !== null) {
        const properties = this.eventProperties[this.event.framerate]
        if (properties !== undefined) this.appendPresets(properties.presets)
      }
      const machineType = this.event.largemachine ? LARGE_MACHINE_TYPE : NORMAL_MACHINE_TYPE
      let machinePresets = this.eventProperties[machineType].presets
      const regionData = this.eventProperties[this.event.region]
      if (regionData?.presets) this.appendPresets(regionData?.presets)
      if (this.event.largemachine) {
        if (regionData?.largemachine_preset) machinePresets = regionData.largemachine_preset
      }
      if (machinePresets) this.appendPresets(machinePresets)
      if (this.ngcvpVersion !== null) this.appendPresets([this.ngcvpVersion])
    },
    //TODO: Maybe refactor all 3 below into a single method
    updateEvent (): void {
      this.$store.direct.dispatch.logs.addLog({ message: 'Update event button clicked', level: 'info' })
      this.$store.direct.dispatch.events.updateCast(this.event).then(() => {
        this.$message({ type: 'success', message: 'Event has been updated' })
        this.$store.direct.dispatch.logs.addLog({ message: 'Update cast event succeeded', level: 'info' })
        this.$router.push({ name: 'home' }) //Go back to Events page
      }).catch(error => {
        console.error('updateEvent Error', error)
      })
    },
    createEventCopy (): void {
      this.$store.direct.dispatch.logs.addLog({ message: 'Copy event button clicked', level: 'info' })
      this.$store.direct.dispatch.events.copyCast(this.event).then(() => {
        this.$message({ type: 'success', message: 'Event copy created' })
        this.$store.dispatch('logs/addLog', { message: 'Copy cast event succeeded', level: 'info' })
        this.$router.push({ name: 'home' }) //Go back to Events page
      }).catch(error => {
        console.error('createEventCopy Error', error)
      })
    },
    createEvent (): void {
      this.$store.direct.dispatch.logs.addLog({ message: 'Create Event button clicked', level: 'info' })
      this.$store.direct.dispatch.events.createCast(this.event).then(() => {
        this.$message({ type: 'success', message: 'Event has been created' })
        this.$store.direct.dispatch.logs.addLog({ message: 'Create Event succeeded', level: 'info' })
        this.$router.push({ name: 'home' }) //Go back to Events page
      }).catch(error => {
        console.error('createEvent Error', error)
      })
    },
    validOutputs (): boolean {
      let valid = true
      Object.keys(this.event.custom_rtmp_destinations || {}).forEach(outputKey => {
        if (outputKey && this.event.custom_rtmp_destinations![outputKey].url === '') {
          valid = false
        }
      })
      return valid
    },
    appendPresets (presets: string[]): void {
      this.event.presets = this.event.presets.concat(presets)
    },
    closePage (): void {
      this.$router.push({ name: 'home' }) //Go back to Events page
    },
    updateOriginalGopInfo (): void {
      this.originalGop = this.event.gop_size
      this.hadOriginalOutputs = Object.keys(this.event.custom_rtmp_destinations ?? {}).length > 0
    },
    loadCastTemplate () {
      if (this.selectedTemplate !== 'default') {
        let template: Partial<CastTemplate>|undefined = this.templates.find(template => template.id === this.selectedTemplate)
        if (template !== undefined) {
          template = Object.assign({}, template)
          delete template.id

          // Make sure we keep all properties reactive in case `template` doesn't have them. (CC-2607)
          // See also: https://vuejs.org/v2/guide/reactivity.html#For-Objects
          this.event = {...this.event, ...template as Cast}
          this.event.name = 'Instance of: ' + template.name
          this.event.watermark = template.watermark ?? WATERMARK_DEFAULT
          this.event.supportLevel = template.supportLevel ?? this.$store.direct.getters.team.defaultSupportLevel
          if (this.isSelfServe) this.event.supportLevel = SupportLevel.Lite // Always use Lite for Self-Serve.
          this.event.platinumApproved = false

          if (!this.heavyDutyAllowed) this.event.largemachine = false
          // this.templateLoaded = true //Not even used
          this.event.gop_size = this.event.gop_size ?? MIXER_DEFAULT_GOP

          if (this.regions.find(item => item.key === this.event.region) === undefined) {
            const teamDefaultRegion = this.$store.direct.state.team.team.default_region
            if (teamDefaultRegion !== undefined && this.regions.find(item => item.key === teamDefaultRegion)) {
              this.event.region = teamDefaultRegion as Region
            } else if (this.regions.length > 0 && this.regions[0].key !== undefined) {
              this.event.region = this.regions[0].key as Region
            } else {
              console.warn('No regions available to assign to cast template.')
            }
          }
        }
        this.updateOriginalGopInfo()
      }
    },
    getObjectLength (obj: object): number {
      return Object.keys(obj).length
    },
    addCaster (): void {
      if (this.selectedCaster === null) return
      const userId = this.selectedCaster
      let invitedCaster = this.event.invited_casters[userId]
      if (invitedCaster === undefined) {
        invitedCaster = new InvitedCaster({ userId })
      }
      invitedCaster.deleted = false
      // use this.$set to also update the computed properties using the invited_casters
      // => Vue cannot detect property addition or deletion, only changes to existing properties.
      this.$set(this.event.invited_casters, userId, invitedCaster)
      this.selectedCaster = null
    },
    removeCaster (userId: string): void {
      this.event.invited_casters[userId].deleted = true
    }
  },
  watch: {
    'event.custom_rtmp_destinations' (newValue: Cast) {
      if (!this.hadOriginalOutputs) return
      if (newValue !== undefined && Object.keys(newValue).length === 0) {
        this.hadOriginalOutputs = false
      }
    },
    'event.start_date' () {
      this.$v.$touch() //Trigger validation recheck on end_date too, to disable form button if needed
    },
    isSelfServe (newVal: boolean){
      console.log('EventWizard: isSelfServe', newVal)
      if(newVal){
        this.event.supportLevel = SupportLevel.Lite
      }
    },
    activeTeam: {
      immediate: true,
      handler () {
        this.event.team_id = this.activeTeam
      }
    },
    eventId: {
      immediate: true,
      async handler () {
        if (this.isEditMode) this.originalEvent = await this.$store.direct.dispatch.events.getSingleEvent(this.eventId)
      }
    },
    originalEvent () {
      if (this.originalEvent?.id) {
        const start = this.originalEvent.start_date
        const end = this.originalEvent.end_date

        //Populate fields with existing values
        this.event = {
          ...cloneDeep(this.originalEvent),
          //Account for inconsistent date structures used in db
          start_date: moment(start.seconds ? start.seconds * 1000 : start).toDate(),
          end_date: moment(end.seconds ? end.seconds * 1000 : end).toDate()
        }
      }
    },
    filteredTeamStreamInputs: {
      immediate: true,
      handler () {
        if (this.isSelfServe) { //Add first input by default
          const firstAvailableInputId = this.filteredTeamStreamInputs[0]?.id
          if (firstAvailableInputId) Vue.set(this.event.input_streams, firstAvailableInputId, true)
        }
      }
    }
  },
  validations: {
    event: {
      name: {
        required,
        minLength: minLength(2)
      },
      gop_size: {
        required,
        between: between(1,6)
      },
      start_date: {
        required,
        minValue (value) {
          const date = moment(value, moment.ISO_8601)
          return date.isValid()
        }
      },
      end_date: {
        required,
        minValue: validDateRange(),
        maxValue: allowedDateRange()
      }
    }
  },
  components: {
    // 'el-steps': Steps,
    // 'el-step': Step,
    'el-table': Table,
    'el-table-column': TableColumn,
    'el-select': Select,
    'el-option': Option,
    'el-popover': Popover,
    'el-date-picker': DatePicker,
    'el-button': Button,
    CastInputSelector,
    StreamOutputs
    // AddCasterToCast
  }
})
